import { collapsibleText } from './collapsibleText'
import { rangeSlider } from './rangeSlider'
import { richContentViewer } from './richContentViewer'
import { slider } from './slider'
import { slideshow } from './slideshow'
import { textEffects } from './textEffects'
import { textEffects3d } from './textEffects3d'
import { textEffectsBauhaus } from './textEffectsBauhaus'
import { textEffectsGlass } from './textEffectsGlass'
import { textEffectsGlitch } from './textEffectsGlitch'
import { textEffectsLetterPress } from './textEffectsLetterPress'
import { textEffectsMatrix } from './textEffectsMatrix'
import { textEffectsNeonSign } from './textEffectsNeonSign'
import { textEffectsNoisy } from './textEffectsNoisy'
import { textEffectsOutlineOut } from './textEffectsOutlineOut'
import { textEffectsRetro } from './textEffectsRetro'
import { textEffectsShared } from './textEffectsShared'
import { textEffectsShook } from './textEffectsShook'
import { textEffectsSticker } from './textEffectsSticker'
import { textEffectsStriped } from './textEffectsStriped'
import { textMarquee } from './textMarquee'
import { textMask } from './textMask'
import { textOnPath } from './textOnPath'
import { leanTestComponent } from './leanTestComponent'
import { productSpecification } from './productSpecification'
import { dashboardButton } from './dashboardButton'
import { dashboardHeading } from './dashboardHeading'
import { dashboardIconButton } from './dashboardIconButton'
import { dashboardInfoIcon } from './dashboardInfoIcon'
import { dashboardInput } from './dashboardInput'
import { dashboardNumberInput } from './dashboardNumberInput'
import { dashboardText } from './dashboardText'
import { dashboardTextButton } from './dashboardTextButton'
import { dashboardToggleSwitch } from './dashboardToggleSwitch'
import { wutBadge } from './wutBadge'

export const eeDefinitionsByType = {
  '$w.CollapsibleText': collapsibleText,
  '$w.RangeSlider': rangeSlider,
  '$w.RichContentViewer': richContentViewer,
  '$w.Slider': slider,
  '$w.Slideshow': slideshow,
  '$w.TextEffects': textEffects,
  '$w.TextEffects3d': textEffects3d,
  '$w.TextEffectsBauhaus': textEffectsBauhaus,
  '$w.TextEffectsGlass': textEffectsGlass,
  '$w.TextEffectsGlitch': textEffectsGlitch,
  '$w.TextEffectsLetterPress': textEffectsLetterPress,
  '$w.TextEffectsMatrix': textEffectsMatrix,
  '$w.TextEffectsNeonSign': textEffectsNeonSign,
  '$w.TextEffectsNoisy': textEffectsNoisy,
  '$w.TextEffectsOutlineOut': textEffectsOutlineOut,
  '$w.TextEffectsRetro': textEffectsRetro,
  '$w.TextEffectsShared': textEffectsShared,
  '$w.TextEffectsShook': textEffectsShook,
  '$w.TextEffectsSticker': textEffectsSticker,
  '$w.TextEffectsStriped': textEffectsStriped,
  '$w.TextMarquee': textMarquee,
  '$w.TextMask': textMask,
  '$w.TextOnPath': textOnPath,
  '$w.LeanTestComponent': leanTestComponent,
  '$w.ProductSpecification': productSpecification,
  '$w.DashboardButton': dashboardButton,
  '$w.DashboardHeading': dashboardHeading,
  '$w.DashboardIconButton': dashboardIconButton,
  '$w.DashboardInfoIcon': dashboardInfoIcon,
  '$w.DashboardInput': dashboardInput,
  '$w.DashboardNumberInput': dashboardNumberInput,
  '$w.DashboardText': dashboardText,
  '$w.DashboardTextButton': dashboardTextButton,
  '$w.DashboardToggleSwitch': dashboardToggleSwitch,
  '$w.WutBadge': wutBadge,
}
